import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetEmployeeAssessmentDetailState, getEmployeeAssessmentDetail as onGetEmployeeAssessmentDetails, addNewEmployeeAssessmentDetail as onAddNewEmployeeAssessmentDetail, updateEmployeeAssessmentDetail as onUpdateEmployeeAssessmentDetail, deleteEmployeeAssessmentDetail as onDeleteEmployeeAssessmentDetail, getEmployeeAssessmentDetailLoading } from "../../../store/employeeAssessmentDetail/action";
import { getEmployeeAssessment as onGetEmployeeAssessments, addNewEmployeeAssessment as onAddNewEmployeeAssessment, updateEmployeeAssessment as onUpdateEmployeeAssessment, deleteEmployeeAssessment as onDeleteEmployeeAssessment, getEmployeeAssessmentLoading, resetEmployeeAssessmentState } from "../../../store/employeeAssessment/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EmployeeAssessment = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [companyName, setCompanyName] = useState({});
  const [clientName, setClientName] = useState({});
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, employeeAssessments, isEmployeeAssessmentCreated, isEmployeeAssessmentSuccess, loading, error, employeeAssessmentDetails, employeeAssessmentDetailLoading, isEmployeeAssessmentDetailCreated, isEmployeeAssessmentDetailSuccess, employees, employeeLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    employeeAssessments: state.EmployeeAssessment.employeeAssessments,
    isEmployeeAssessmentCreated: state.EmployeeAssessment.isEmployeeAssessmentCreated,
    isEmployeeAssessmentSuccess: state.EmployeeAssessment.isEmployeeAssessmentSuccess,
    loading: state.EmployeeAssessment.loading,
    error: state.EmployeeAssessment.error,
    employeeAssessmentDetails: state.EmployeeAssessmentDetail.employeeAssessmentDetails,
    employeeAssessmentDetailLoading: state.EmployeeAssessmentDetail.loading,
    isEmployeeAssessmentDetailCreated: state.EmployeeAssessmentDetail.isEmployeeAssessmentDetailCreated,
    isEmployeeAssessmentDetailSuccess: state.EmployeeAssessmentDetail.isEmployeeAssessmentDetailSuccess,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [employeeAssessmentList, setEmployeeAssessmentList] = useState([]);
  const [employeeAssessment, setEmployeeAssessment] = useState([]);
  const [assessmentDetailAddedId, setAssessmentDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [statusActive, setStatusActive] = useState([]);
  const [employeeAssessmentDetail, setEmployeeAssessmentDetail] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [employee, setEmployee] = useState(null);
  const [isApprover, setIsApprover] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const ref = useRef(null);

  const onClickDelete = (employeeAssessment) => {
    setEmployeeAssessment(employeeAssessment);
    setDeleteModal(true);
  };

  const handleDeleteEmployeeAssessment = () => {
    if (employeeAssessment) {
      dispatch(onDeleteEmployeeAssessment(employeeAssessment));
      setDeleteModal(false);
    }
  };

  const onClickApprove = (employee) => {
    setEmployeeAssessment(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredEmployeeAssessments = employeeAssessments;
      if (type !== "all") {
        filteredEmployeeAssessments = employeeAssessments.filter((employeeAssessment) => employeeAssessment.kpiea_status.name === type);
      }
      setEmployeeAssessmentList(filteredEmployeeAssessments);
    }
  };

  useEffect(() => {
    if (companySelected) {
      dispatch(resetEmployeeAssessmentState());
      dispatch(onGetEmployeeAssessments({ companyId: companySelected?.value ?? "", type: "KPI" }));
    }
  }, [companySelected]);

  useEffect(() => {
    if (!employee) {
      const emp = JSON.parse(localStorage.getItem("authUser"));
      if (emp.data && emp.data.userType) {
        let approver = false;
        for (const element of emp.data.userType) {
          if (element.method === "approveEmployeeAssessment") approver = true;
        }
        setIsApprover(approver);
        dispatch(resetEmployeeState());
        if (approver)
          dispatch(
            getEmployee({
              departmentId: emp.data.user?.user_department ? emp.data.user?.user_department?.id : null,
              type: "referral",
              status: 2,
            })
          );
        else dispatch(getEmployee({ id: emp.data.userId, type: "referral", status: 2 }));
      }
    }
  }, [employee, isAdmin, dispatch]);

  useEffect(() => {
    if (!isEmpty(employeeAssessments) && isSearch) {
      setIsEdit(false);
      let filteredEmployeeAssessments = employeeAssessments;
      if (activeTypeTab !== "all") {
        filteredEmployeeAssessments = employeeAssessments.filter((employeeAssessment) => employeeAssessment.kpiea_status.name === activeTypeTab);
      }
      setEmployeeAssessmentList(filteredEmployeeAssessments);
      let current = 0;
      if (assessmentDetailAddedId !== 0) {
        employeeAssessments.forEach((obj, i) => {
          if (obj.id === assessmentDetailAddedId) current = i;
        });
      }

      setInfo(employeeAssessments[current]);
    }
  }, [employeeAssessments, assessmentDetailAddedId, isSearch]);

  useEffect(() => {
    if (isEmployeeAssessmentDetailCreated) {
      dispatch(resetEmployeeAssessmentDetailState());
      dispatch(resetEmployeeAssessmentState());
      dispatch(onGetEmployeeAssessments({ type: "KPI" }));
    }
  }, [dispatch, isEmployeeAssessmentDetailCreated]);

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [];
      employees.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const companyId = item.companyId;
        const positionId = item.positionId;
        var obj = {
          label: name,
          value: id,
          companyId: companyId,
          positionId: positionId,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setEmployeeList(data);
    }
  }, [employees]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setEmployeeAssessment(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleEmployeeAssessmentClick = useCallback(
    (arg) => {
      const data = arg;
      setEmployeeAssessment({
        id: data.id,
        assessmentat: data.startat + " to " + data.endat,
        percentage: data.percentage,
        company: {
          label: data.kpiea_company.name,
          value: data.kpiea_company.id,
        },
        client: {
          label: data.kpiea_client.name,
          value: data.kpiea_client.id,
        },
        employee: {
          label: data.kpiea_employee.name,
          value: data.kpiea_employee.id,
          companyId: data.kpiea_employee.companyId,
          positionId: data.kpiea_position.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setEmployeeAssessmentDetail(null);
      setEmployeeAssessment(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleEmployeeAssessmentDetailClick = useCallback(
    (arg, arginfo, isEdit) => {
      const data = arg;

      setEmployeeAssessmentDetail({
        id: data.id,
        perspective: data.perspective,
        target: data.target,
        percentage: data.percentage,
        assessor_description: data.assessor_description,
        assessor_score: data.assessor_score,
        realization: data.realization,
        realization_description: data.realization_description,
        assessmentId: data.assessmentId,
        isTraining: data.isTraining,
        score: data.kpiead_pp && {
          label: data.kpiead_pp.name,
          value: data.kpiead_pp.id,
        },
      });

      setIsEditDetail(isEdit);
      toggleDetail();
    },
    [toggleDetail]
  );

  const columns = useMemo(
    () => [
      {
        Header: "Karyawan",
        accessor: "kpiea_employee.name",
        filterable: true,
      },
      {
        Header: "Periode",
        accessor: "startat",
        filterable: true,
        Cell: (data) => <>{handleValidDate(data.row.original.startat)}</>,
      },
      {
        Header: "Oleh Karyawan",
        filterable: true,
        Cell: (data) => <>{data.row.original.total_realization}</>,
      },
      {
        Header: "Oleh Penilai",
        filterable: true,
        Cell: (data) => <>{data.row.original.total_asessor}</>,
      },
      {
        Header: "Status",
        accessor: "kpiea_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              {cellProps.row.original.statusId === 10 ? (
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("approveEmployeeAssessment") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"}
                  onClick={() => {
                    let data = cellProps.row.original;
                    onClickApprove(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                  Approve
                </button>
              ) : (
                ""
              )}
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-light"
                onClick={() => {
                  setInfo(cellProps.row.original);
                  ref.current?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <i className="ri-eye-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={userType === "admin" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateEmployeeAssessment") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                onClick={() => {
                  handleEmployeeAssessmentClick(cellProps.row.original);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={userType === "admin" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteEmployeeAssessment") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                onClick={() => {
                  const employeeAssessmentData = cellProps.row.original;
                  onClickDelete(employeeAssessmentData);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
    ],
    [handleEmployeeAssessmentClick, userRole, userType]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: employeeAssessmentList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveAssessment = () => {
    if (employeeAssessment) {
      employeeAssessment.setApprove = true;
      dispatch(onUpdateEmployeeAssessment(employeeAssessment));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      assessmentat: employeeAssessment && employeeAssessment.assessmentat,
      employee: employeeAssessment && employeeAssessment.employee,
    },
    validationSchema: Yup.object({
      assessmentat: Yup.string().required("Please Enter Assessment Date").nullable(true),
      employee: Yup.object().required("Please Enter Employee").nullable(true),
    }),
    onSubmit: (values) => {
      let datearr = values.assessmentat.split(" to ");
      let startat = datearr[0] && datearr[0];
      let endat = datearr[1] ? datearr[1] : datearr[0] && datearr[0];

      dispatch(getEmployeeAssessmentLoading());
      if (isEdit) {
        const updateEmployeeAssessment = {
          id: employeeAssessment ? employeeAssessment.id : 0,
          startat: startat,
          endat: endat,
          employeeId: values.employee.value,
          positionId: values.employee.positionId,
          type: "KPI",
          companyId: values.employee.companyId,
          clientId: values.employee.clientId,
          statusId: 2,
        };
        dispatch(onUpdateEmployeeAssessment(updateEmployeeAssessment));
        validation.resetForm();
      } else {
        const newEmployeeAssessment = {
          startat: startat,
          endat: endat,
          type: "KPI",
          employeeId: values.employee.value,
          positionId: values.employee.positionId,
          companyId: values.employee.companyId,
          clientId: values.employee.clientId,
          statusId: 2,
        };
        dispatch(onAddNewEmployeeAssessment(newEmployeeAssessment));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    enableReinitialize: true,
    initialValues: {
      assessmentId: (employeeAssessmentDetail && employeeAssessmentDetail.assessmentId) || (info && info.id),
      employeeId: info && info.employeeId,
      assessor_score: (employeeAssessmentDetail && employeeAssessmentDetail.assessor_score) || 0,
      assessor_description: (employeeAssessmentDetail && employeeAssessmentDetail.assessor_description) ?? "",
      realization_description: (employeeAssessmentDetail && employeeAssessmentDetail.realization_description) ?? "",
      realization: (employeeAssessmentDetail && employeeAssessmentDetail.realization) || 0,
      isTraining: (employeeAssessmentDetail && employeeAssessmentDetail.isTraining) || false,
    },
    validationSchema: Yup.object({
      realization_description: Yup.string().required("Please Enter Realization Description").nullable(true),
      realization: Yup.number().required("Please Enter Realization Percentage").nullable(true),
    }),
    onSubmit: (values) => {
      setAssessmentDetailAddedId(values.assessmentId);
      dispatch(getEmployeeAssessmentDetailLoading());
      const updateEmployeeAssessmentDetail = {
        id: employeeAssessmentDetail ? employeeAssessmentDetail.id : 0,
        assessmentId: values.assessmentId,
        employeeId: values.employeeId,
        type: "KPI",
        assessor_score: values.assessor_score,
        assessor_description: values.assessor_description,
        realization: values.realization,
        realization_description: values.realization_description,
        isTraining: values.isTraining,
      };
      dispatch(onUpdateEmployeeAssessmentDetail(updateEmployeeAssessmentDetail));
      validationDetail.resetForm();
      toggleDetail();
    },
  });

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteEmployeeAssessmentDetail(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      type: "KPI",
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetEmployeeAssessments(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setEmployeeAssessmentList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetEmployeeAssessmentState());
    dispatch(onGetEmployeeAssessments({ companyId: companySelected?.value ?? "", type: "KPI" }));
  };

  document.title = "Penilaian | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal data={employeeAssessment && employeeAssessment.kpiea_employee ? employeeAssessment.kpiea_employee.name : ""} show={approveModal} onApproveClick={handleApproveAssessment} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteEmployeeAssessment} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Penilaian Karyawan" pageTitle="Penelitian" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createEmployeeAssessment") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setEmployeeAssessment(null);
                setIsEdit(false);
                toggle();
              }}
            >
              <i className=" ri-star-line me-1 align-bottom fs-14"></i>Tambah
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={7}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-star-line me-1 align-bottom fs-14"></i>SEMUA PENILAIAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1} className="col-xxl-3">
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={7}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Penilaian" : "Tambah Penilaian"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="employee" className="form-label">
                            Karyawan
                            {employeeLoading ? (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </Label>
                          <Select
                            name="employee"
                            value={userType === "admin" ? validation.values.company : companyName}
                            isDisabled={!isApprover}
                            placeholder="Enter Employee"
                            onChange={(e) => {
                              validation.setFieldValue("employee", e);
                            }}
                            options={employeeList}
                            noOptionsMessage={(e) => "Type Employee to get option"}
                            invalid={validation.touched.employee && validation.errors.employee ? true : false}
                          ></Select>
                          {validation.touched.employee && validation.errors.employee ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.employee}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="assessmentat-field" className="form-label">
                            Periode Penilaian
                          </Label>
                          <Flatpickr
                            name="assessmentat"
                            className="form-control"
                            id="assessmentat"
                            placeholder="Select Assessment Range Date"
                            value={validation.values.assessmentat}
                            options={{
                              mode: "range",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(obj, str) => {
                              validation.setFieldValue("assessmentat", str);
                            }}
                          />
                          {validation.touched.assessmentat && validation.errors.assessmentat ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.assessmentat}
                            </small>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Ubah Realisasi" : "Tambah Realisasi"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="mb-4 fs-14">
                        {employeeAssessmentDetail && employeeAssessmentDetail.perspective},{employeeAssessmentDetail && employeeAssessmentDetail.target}
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3 ">
                            <Label htmlFor="realization-field" className="form-label">
                              % Realisasi
                            </Label>
                            <Input
                              name="realization"
                              id="realization-field"
                              className="form-control"
                              placeholder="Enter Value To"
                              type="number"
                              onChange={(e) => {
                                /*(employeeAssessmentDetail && employeeAssessmentDetail.percentage < Number(e.target.value)) ? validationDetail.setFieldValue("realization", employeeAssessmentDetail.percentage) :*/ validationDetail.setFieldValue("realization", Number(e.target.value));
                              }}
                              onBlur={validationDetail.handleBlur}
                              disabled={employee && employee.id === info.employeeId ? false : true}
                              value={validationDetail.values.realization}
                              invalid={validationDetail.touched.realization && validationDetail.errors.realization ? true : false}
                            />
                            {validationDetail.touched.realization && validationDetail.errors.realization ? <FormFeedback type="invalid">{validationDetail.errors.realization}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 col-lg-12">
                            <Label htmlFor="realization_description-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input
                              name="realization_description"
                              id="realization_description-field"
                              rows="6"
                              className="form-control"
                              placeholder="Description"
                              type="textarea"
                              onChange={validationDetail.handleChange}
                              onBlur={validationDetail.handleBlur}
                              disabled={employee && employee.id === info.employeeId ? false : true}
                              value={validationDetail.values.realization_description}
                              invalid={validationDetail.touched.realization_description && validationDetail.errors.realization_description ? true : false}
                            />
                            {validationDetail.touched.realization_description && validationDetail.errors.realization_description ? <FormFeedback type="invalid">{validationDetail.errors.realization_description}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3 ">
                            <Label htmlFor="assessor_score-field" className="form-label">
                              % Realisasi (diisi oleh penilai)
                            </Label>
                            {/* max={employeeAssessmentDetail && employeeAssessmentDetail.percentage} */}
                            <Input
                              name="assessor_score"
                              id="assessor_score-field"
                              className="form-control"
                              placeholder="Enter Realization"
                              type="number"
                              onChange={(e) => {
                                /* (employeeAssessmentDetail && employeeAssessmentDetail.percentage < Number(e.target.value)) ? validationDetail.setFieldValue("assessor_score", employeeAssessmentDetail.percentage) :*/ validationDetail.setFieldValue("assessor_score", Number(e.target.value));
                              }}
                              disabled={employee && employee.id === info.employeeId ? true : false}
                              onBlur={validationDetail.handleBlur}
                              value={validationDetail.values.assessor_score}
                            />
                          </div>
                          <div className="mb-3 col-lg-12">
                            <Label htmlFor="assessor_description-field" className="form-label">
                              Keterangan (diisi oleh penilai)
                            </Label>
                            <Input name="assessor_description" id="assessor_description-field" rows="6" className="form-control" placeholder="Description" type="textarea" onChange={validationDetail.handleChange} disabled={employee && employee.id === info.employeeId ? true : false} onBlur={validationDetail.handleBlur} value={validationDetail.values.assessor_description} />
                          </div>
                          <div className="mb-3">
                            <Input name="isTraining" id="isTraining-field" className="form-check-input" type="checkbox" onChange={validationDetail.handleChange} disabled={employee && employee.id === info.employeeId ? true : false} onBlur={validationDetail.handleBlur} checked={validationDetail.values.isTraining} /> &nbsp;
                            <Label htmlFor="isTraining-field" className="form-label">
                              Karyawan membutuhkan pelatihan di bagian ini
                            </Label>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={5}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">{info.startat && info.kpiea_employee ? info.kpiea_employee.name + " - " + handleValidDate(info.startat) + " to " + handleValidDate(info.endat) : " - "}</h5>
              </div>
              <div className="card-body" ref={ref}>
                {/* <Grid
                  data={info.kpiea_detail || []}
                  columns={[
                    {
                      name: _(
                        <span className="text-muted">
                          Keterangan Penilaian Kinerja
                        </span>
                      ),
                      id: "Performance Appraisal Description",
                      width: "58%",
                      data: (row) => row,
                      formatter: (cell) =>
                        _(
                          <div>
                            <p className="fw-semibold mb-2 text-success">
                              {cell.perspective}
                            </p>
                            <p className="fw-semibold mb-1">{cell.target}</p>
                            <p className="mb-3">{cell.description}</p>
                            <p className="fw-semibold mb-1">
                              Indikator, Measures dan Targe
                            </p>
                            <p className="mb-3">{cell.indicator}</p>
                            <div className="hstack gap-2 mt-4 mt-sm-0">
                              <p className="fw-semibold mb-1">Karyawan:</p>
                              <p className="mb-1">
                                <span
                                  className={
                                    cell.realization && cell.realization > 0
                                      ? "badge text-uppercase badge-soft-info fw-semibold fs-12 me-1"
                                      : "badge text-uppercase badge-soft-warning fw-semibold fs-12 me-1"
                                  }>
                                  {cell.realization || 0} %
                                </span>
                                <span
                                  className={
                                    cell.employee_value &&
                                    cell.employee_value > 0
                                      ? "badge text-uppercase badge-soft-success fw-semibold fs-12"
                                      : "badge text-uppercase badge-soft-warning fw-semibold fs-12"
                                  }>
                                  {cell.employee_value}
                                </span>
                              </p>
                            </div>
                            <p className="mb-3">
                              <em>{cell.realization_description || "-"}</em>
                            </p>
                            <div className="hstack gap-2 mt-4 mt-sm-0">
                              <p className="fw-semibold mb-1">Penilai:</p>
                              <p className="mb-1">
                                <span
                                  className={
                                    cell.assessor_score &&
                                    cell.assessor_score > 0
                                      ? "badge text-uppercase badge-soft-info fw-semibold fs-12 me-1"
                                      : "badge text-uppercase badge-soft-warning fw-semibold fs-12 me-1"
                                  }>
                                  {cell.assessor_score} %
                                </span>
                                <span
                                  className={
                                    cell.assessor_value &&
                                    cell.assessor_value > 0
                                      ? "badge text-uppercase badge-soft-success fw-semibold fs-12"
                                      : "badge text-uppercase badge-soft-warning fw-semibold fs-12"
                                  }>
                                  {cell.assessor_value}
                                </span>
                              </p>
                            </div>
                            <p className="mb-3">
                              <em>{cell.assessor_description || "-"}</em>
                            </p>
                            <button
                              className="btn-label btn btn-sm btn-success fs-13 me-0"
                              onClick={() => {
                                handleEmployeeAssessmentDetailClick(
                                  cell,
                                  info,
                                  true
                                );
                              }}><i className="ri-pencil-line label-icon align-middle me-0"></i>
                              Realisasi
                            </button>
                          </div>
                        ),
                    },
                  ]}
    Search={false}
                  fixedHeader={true}
                  height={"600px"}
                  sort={true} /> */}
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EmployeeAssessment;
